import { useState, useEffect, useCallback } from "react";

const NOTIF_DISMISSED_KEY = "nigunim:notifDismissed";
const NOTIF_SUBSCRIBED_KEY = "nigunim:notifSubscribed";

export function useNotificationPermission(isInstalled: boolean, gamesAfterInstall: number) {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    if (!isInstalled) return;
    if (gamesAfterInstall < 1) return;
    if (localStorage.getItem(NOTIF_DISMISSED_KEY) === "true") return;
    if (localStorage.getItem(NOTIF_SUBSCRIBED_KEY) === "true") return;
    if (!("Notification" in window)) return;
    if (Notification.permission === "granted") return;
    if (Notification.permission === "denied") return;

    setShowBanner(true);
  }, [isInstalled, gamesAfterInstall]);

  const dismiss = useCallback(() => {
    localStorage.setItem(NOTIF_DISMISSED_KEY, "true");
    setShowBanner(false);
  }, []);

  const onSubscribed = useCallback(() => {
    localStorage.setItem(NOTIF_SUBSCRIBED_KEY, "true");
    setShowBanner(false);
  }, []);

  return { showBanner, dismiss, onSubscribed };
}
